export default {
  register: "新規登録",
  welcome: "ようこそ",
  textWelcome: "いらっしゃいませ",
  textGoodMorning: "おはようございます",
  textGoodAfternoon: "こんにちは",
  textGoodEvening: "こんばんは",
  textGoodNight: "おやすみなさい",
  loginFail: "ログインに失敗しました",
  phone: "電話番号",
  email: "メールアドレス",
  agreeTermAndCondition: "利用規約に同意する",
  pleaseAgreeTermAndCondition: "プライバシーポリシーに同意してください",
  back: "戻る",
  termAndCondition: "利用規約",
  termAndCondition2: "利用規約",
  cancel: "キャンセル",
  confirm: "確認",
  confirmDefault: "登録を確定する",
  confirmRegistration: "确认注册",
  addItem: "項目を追加",
  required: "この項目は必須です",
  zipcode: "郵便番号",
  sub_district: "町名・番地",
  district: "市区町村",
  province: "都道府県",
  save: "保存",
  saveDraft: "下書きを保存",
  close: "閉じる",
  name: "名",
  surname: "姓",
  birthDay: "生年月日",
  gender: "性別",
  educationLevel: "最終学歴",
  jobLevel: "職位",
  jobPosition: "役職",
  department: "部署",
  company: "会社名",
  address: "住所",
  enterRegister: "登録する",
  management: "経営層",
  manager: "マネージャー",
  supervisor: "スーパーバイザー",
  officer: "一般社員",
  worker: "現場作業員",
  doctorate: "博士",
  masterDegree: "修士",
  bachelorDegree: "学士",
  highVocational: "専門学校（高度）",
  technicalVocational: "専門学校",
  vocational: "職業訓練",
  highSchool: "高校",
  secondarySchool: "中学校",
  primarySchool: "小学校",
  lowerPrimary: "初等教育未満",
  male: "男性",
  female: "女性",
  other: "その他",
  profile: "プロフィール",
  id: "ID",
  nameSurname: "氏名",
  sendRefCodeOtp: "リファレンスコード",
  requestOtpAgain: "OTPを再送する",
  edit: "編集",
  add: "追加",
  addressSendReward: "お届け先住所",
  addressDetail: "住所詳細",
  selectDefautAddress: "既定の住所に設定",
  addressEdit: "住所を編集",
  addressAdd: "住所を追加",
  defaultValue: "デフォルト値",
  hello: "こんにちは、{name}様",
  coinTotal: "累計ポイント",
  homePage: "ホーム",
  activityPage: "イベント",
  redemptPage: "特典交換",
  invitePage: "友達招待",
  connectPlatformPage: "連携プラットフォーム",
  connectPlatformPageHint: "ECサイトと連携して特典を受け取る",
  birthDayPage: "バースデーギフト",
  addressPage: "お届け先管理",
  favoritePage: "お気に入り",
  cancelShipment: "配送キャンセル",
  couponPage: "マイクーポン",
  myLuckyDrawPage: "マイ抽選",
  myMemberPage: "マイメンバー",
  registerMemberPage: "会員登録",
  statusDeliveryPage: "配送状況確認",
  transferPage: "ポイント移行",
  logout: "ログアウト",
  textCategory: "カテゴリー",
  categoryAll: "すべて",
  categoryRecommend: "おすすめ",
  categoryFood: "フード",
  categoryElectrical: "家電",
  categoryAppliance: "日用品",
  categoryOther: "その他",
  totalValue: "残り数量",
  detail: "詳細",
  seeMoreDetail: "詳細",
  youWant: "しますか？ ",
  delete: "削除",
  favoriteText: "お気に入りに追加済み",
  waitingLoad: "読み込み中...",
  expireTime: "期限切れ",
  coin: "ポイント",
  surveyRegister: "登録フォーム",
  later: "後で",
  redeem: "交換する",
  redeemPoint: "使用ポイント",
  confirmRedeem: "ポイントを使用して交換しますか？",
  confirmAdd: "追加しますか？",
  inYourFav: "をお気に入りに追加",
  confirmDelete: "削除しますか？",
  fromYourFav: "をお気に入りから削除",
  balance: "残高",
  inviteFrindDetail: "友達を招待して、友達が登録を完了すると特典がもらえます。",
  received: "受取済み",
  inviteFriend: "友達を招待",
  inviteFriendPhoneText: "招待する友達の電話番号を入力",
  inviteFriendLineText: "LINEで友達を招待",
  fillPhone: "友達の電話番号を入力",
  historyRedeem: "交換履歴",
  historyCode: "コード履歴",
  resendCode: "コードを再送",
  coinAll: "総合",
  coinReceived: "獲得ポイント",
  coinUsed: "使用ポイント",
  activityAll: "すべてのイベント",
  expireDate: "有効期限",
  note: "備考",
  enterNote: "備考を入力...",
  checkIn: "チェックイン",
  activityExpireDate: "イベント終了日",
  collectCoin: "ポイントを貯める",
  valueItem: "数量",
  missionReward: "報酬",
  activityJoin: "イベントに参加",
  activityQr: "QRコードをスキャン",
  activitySurvey: "アンケートに回答",
  activityUpload: "活動結果をアップロード",
  activityScanQr: "スキャン",
  scanCode: "コードをスキャン",
  sendSurvey: "アンケートを送信",
  uploadFile: "ファイルをアップロード",
  sizeFile: "ファイルサイズは10MB以下にしてください",
  activityStatusJoin: "参加中",
  activityStatusWait: "承認待ち",
  activityStatusSuccess: "完了",
  activityStatusReject: "不承認",
  activityStatusAll: "すべての活動",
  registerToReceive: "登録して受け取る",
  confirmUseCoupon: "クーポンを使用しますか？",
  noteUseCoupon:
    "権利消失を防ぐため、店舗のスタッフの前で操作することをお勧めします。",
  noteAlertUseCoupon:
    "「使用する」をクリックすると、即座に使用済みとなります。",
  codeDiscount: "割引コード",
  errorQr: "表示に失敗しました",
  cancelRedemption: "取引をキャンセルしますか？",
  cancelRedemptionNote: "キャンセルするとポイントは付与されません。",
  statusDelivery: "特典の配送状況",
  statusSendIn7Day: "7日以内に発送予定",
  shippingInProcess: "配送準備中",
  statusDeliverySuccess: "配送完了",
  statusDeliveryCancel: "配送キャンセル",
  trackingNumber: "追跡番号",
  receiveReward: "特典を受け取る",
  copyText: "コピーしました",
  confirmReceiveReward: "特典の受け取りを確認する",
  activitySuggest: "おすすめのイベント",
  pageNotFound: "ページが見つかりません",
  goBackPage: "前のページへ戻る",
  goToLogin: "ログインページへ",
  changeLanguage: "言語切替",
  all: "すべて",
  join: "参加",
  joined: "joined",
  success: "成功",
  failed: "失敗",
  waiting: "待機中",
  pending: "保留中",
  sent: "送信済み",
  delivered: "配達済み",
  textRequireOTPAgain: "再送まであと : ",
  welcomeActivity: "イベントへようこそ",
  errQr: "無効なQRコードです。もう一度お試しください。",
  requireExam: "アンケートをすべて入力してください。",
  uploadSuccess: "送信が完了しました。",
  uploadWaiting: "7日以内に内容を確認いたします。",
  errDupActivity:
    "このタスクは既に完了しています。他のイベントを選んでください。",
  errExpireActivity: "申し訳ありません。このイベントは終了しました。",
  errActivity: "申し訳ありません。このイベントの参加資格がありません。",
  errFileUpload: "ファイルサイズは10MB以下にする必要があります。",
  errMyLuckyDrawNotEnough: "申し訳ありません。抽選権が不足しています。",
  expireDateUse: "使用期限",
  registerPage: "登録ページ",
  shareActivity: "イベントをシェア",
  goToMission: "ミッションを見る",
  menuActivity: "イベント",
  menuRedeem: "特典交換",
  menuCoupon: "マイクーポン",
  privacyPolicy: "プライバシーポリシー",
  favoriteCategory: "お気に入り",
  deviceCategory: "電子機器",
  accessoryCategory: "アクセサリ",
  healthCategory: "ヘルス＆ビューティー",
  foodCategory: "フード＆ドリンク",
  babyCategory: "ベビー＆キッズ",
  petCategory: "ペット用品",
  homeCategory: "ホーム＆ライフスタイル",
  menCategory: "メンズファッション",
  womenCategory: "レディースファッション",
  sportCategory: "スポーツ",
  travelCategory: "旅行",
  reward: "特典",
  missionComing: "公開予定",
  startDate: "開始日",
  endDate: "終了日",
  home: "ホーム",
  activity: "イベント",
  tracking: "配送状況",
  account: "マイページ",
  historyCoupon: "クーポン履歴",
  rewardSoHot: "人気特典",
  hotMission: "人気イベント",
  recommendMission: "おすすめイベント",
  doneDetailMission: "参加詳細",
  detailMission: "イベント詳細",
  newActivityUpload: "再提出",
  errNotTimeForActivity: "イベント開始前です。",
  news: "ニュース",
  birthDayGift: "バースデーギフト",
  friendRecommend: "おすすめの友達",
  friendRequest: "友達リクエスト",
  friendList: "友達リスト",
  rewardLimitReached: "在庫上限に達しました",
  limitReached: "上限に達しました",
  limitReachedPerDay: "1日の上限に達しました",
  textComingSoon: "近日公開",
  textTimeCannotJoin: "期間外です",
  couponExpired: "クーポン期限切れ",
  myLuckyDrawExpire: "期限切れ",
  conditionCoin: "利用規約が適用されます",
  rewardPrize: "賞品",
  agree: "同意する",
  disagree: "同意しない",
  activityHeartToHeart: "メッセージを送る",
  rewardComingSoon: "近日公開",
  addMember: "メンバー追加",
  conditionEntryPass: "参加条件",
  letsJoin: "今すぐ参加",
  isUsed: "使用済み",
  editProfile: "プロフィール編集",
  textProfile: "プロフィール",
  searchMissionOrReward: "イベントや特典を検索",
  searchHistory: "検索履歴",
  removeSearchHistory: "履歴を削除",
  messageActivityUpcoming: "お楽しみに！新しいイベントが始まります 🎉",
  messageActivityErrorReJoin:
    "失敗しました。イベントページから再度参加してください。",
  errActivityAlreadyJoined: "既にこのイベントに参加しています。",
  errActivityDataNotFound: "イベント情報が見つかりません。",
  redeemSuccessWithClaimInstruction:
    "交換に成功しました！「マイクーポン」から特典を確認してください。",
  redeemSuccess: "交換成功",
  errRewardOutOfStock: "申し訳ありません。在庫切れです。",
  errRedeemFail: "交換に失敗しました。もう一度お試しください。",
  textSorry: "申し訳ありません、",
  errDataNotFound: "データが見つかりません。",
  errSubmissionFailed: "送信に失敗しました。もう一度お試しください。",
  errRegistrationFailedContactAdmin:
    "登録に失敗しました。管理者にお問い合わせください。",
  btnRedirectMyCoupon: "マイクーポンへ",
  infoCouponReadyMyCoupons: "獲得したクーポンはマイクーポンから利用できます。",
  coinCost: "必要ポイント",
  next: "次へ",
  skip: "スキップ",
  otpVerified: "OTP認証済み",
  successOTPVerified: "OTP認証に成功しました",
  dataNotFound: "データがありません",
  version: "バージョン",
  viewAll: "すべて見る",
  availableStock: "在庫数",
  expiredAt: "期限",
  expiredAt2: "有効期限",
  rewardToReceive: "受け取る特典",
  chooseRewardToReceive: "特典を選択してください",
  viewResultActivity: "活動結果を見る",
  titleInvite:
    "{name}様から招待が届きました。ロイヤリティプログラムに参加して特典をゲットしましょう！",
  thankYouForParticipatingActivity: "ご参加ありがとうございました！",
  doActivityBy: "実行者:",
  textNotSpecified: "未設定",
  textIncognito: "匿名モード",
  viewHistory: "履歴を見る",
  history: "履歴",
  locationName: "場所名",
  location: "場所",
  selectRedeemRewardLocation: "受取場所を選択",
  selectAddressSendReward: "お届け先住所を選択",
  instructionAddAddressSendReward: "お届け先住所を追加してください。",
  textSelect: "選択",
  instructionEnterRegisteredPhone:
    "既にアカウントをお持ちの場合は、登録済みの電話番号を入力してください。",
  instructionEnterRegisteredEmail:
    "既に登録済みの場合は、登録したメールアドレスを入力してください。",
  textFirstRegistration: "初めての登録はこちら",
  textClickHere: "こちらをクリック",
  statusRegistrationSuccess: "登録成功",
  statusRegistrationFailed: "登録失敗",
  instructionUploadIDPassport:
    "身分証明書またはパスポートをアップロードしてください。",
  textUploadIDPassport: "身分証明書/パスポートをアップロード",
  rewardStartDate: "交換開始日",
  rewardExpiredDate: "特典有効期限",
  detailMyLuckyDraw: "エントリー詳細",
  date: "日付",
  errUserNotFound: "ユーザーが見つかりません。",
  textSelectUser: "ユーザーを選択",
  textSelectFile: "ファイルを選択",
  textImageType: "画像",
  textVideoType: "動画",
  instructionSelectOrAddAddress: "住所を選択または追加してください。",
  instructionSelectRewardMission: "特典を{amount}個選択してください。",
  textTopRanking: "ランキング",
  textRank: "順位",
  textTotalAmount: "合計金額",
  viewProfile: "プロフィールを見る",
  addFriend: "友達追加",
  cancelFriend: "友達解除",
  removeFriendSuccess: "友達から削除しました",
  instructionUploadImageVideo: "画像/動画をアップロード (最大 {size}MB)",
  textUnsupportedFileType: "対応していないファイル形式です。",
  textAdditionalDescription: "補足説明",
  textDescription: "詳細説明",
  textLocationOrBranchName: "場所 / 店舗名",
  textCheckInTime: "チェックイン時間",
  textCheckOutTime: "チェックアウト時間",
  textLastUpdate: "最終更新",
  instructionLineReopenExternalBrowser:
    "ログインするために外部ブラウザで開き直してください。",
  errPhoneIsUsed: "この電話番号は既に使用されています。",
  textConditionEntryPassGamification: "参加条件",
  textFree: "無料",
  textCongratsReceived: "おめでとうございます！ 🎉 {reward}を獲得しました",
  happyBirthMonth: "誕生月おめでとうございます！",
  happyBirthMonthWish:
    "素敵な1日になりますように。たくさんの笑顔とプレゼントに恵まれる1年でありますように！ 🎁",
  confirmDeleteMember: "メンバー {name} を削除してもよろしいですか？",
  removeMemberSuccess: "メンバーを削除しました",
  removeMemberFail: "メンバーの削除に失敗しました",
  confirmEditProfile: "プロフィールの変更を保存しますか？",
  bonusCoin: "ボーナスポイント",
  receiveCoin: "ポイントを獲得しました",
  status: "ステータス",
  checkSendCodeHistory: "獲得したクーポンはマイクーポンから利用できます。",
  errTimeOut: "タイムアウトしました。",
  inviteHeadline: "友達が増えるともっと楽しい！",
  inviteFriendNow: "友達を招待しよう！",
  copyInviteLink: "招待リンクをコピー",
  copyInviteLinkSuccess: "招待リンクをクリップボードにコピーしました",
  detailScanQrCode: "QRコードを枠内に収めてください。",
  pleaseFill: "入力してください",
  comment: "コメント",
  claimSpecialGift: "特別ギフトを受け取る",
  claimGift: "ギフトを受け取る",
  claimGiftSuccess: "ギフトを受け取りました",
  list: "リスト",
  summary: "概要",
  collected: "獲得済み",
  collectedItemCount: "{count} 個獲得",
  invalidPhoneNumber: "有効な電話番号を入力してください",
  duplicateData: "重複データがあります",
  saveSuccess: "保存しました",
  uploadSuccessful: "アップロード成功",
  memberLevel: "現在のランク",
  maxLevelReached: "最高ランクに到達しました！おめでとうございます 🎉",
  // earnMoreForNextLevel:
  //   "あと {nextLevelEarn} ポイントで {nextLevelName} にランクアップ",
  earnMoreForNextLevel:
    "あと {nextLevelEarn} で {nextLevelName} にランクアップ",
  code: "コード",
  codeNo: "コード No. {no}",
  qrCode: "QRコード",
  barCode: "バーコード",
  removeCache: "キャッシュを削除",
  connect: "連携する",
  luckyDrawCount: "残り回数",
  locationAccessDenied: "位置情報を取得できません。設定を確認してください。",
  viewing: "閲覧中",
  cameraError: {
    notAllowed: "カメラの使用を許可してください",
    notFound: "エラー: カメラが見つかりません",
    notSupported: "エラー: セキュアな接続(HTTPS)が必要です",
    notReadable: "エラー: カメラが既に使用されている可能性があります",
    overconstrained: "エラー: カメラの要件が適合しません",
    streamApiNotSupported:
      "エラー: このブラウザはストリームAPIに対応していません",
    insecureContext: "エラー: HTTPS接続が必要です",
    unknown: "エラー: カメラエラー ({error_name})",
  },
  error: {
    title: "エラーが発生しました",
    general: "問題が発生しました。もう一度お試しください。",
    unknown: "不明なエラーが発生しました",
    network: "ネットワークエラー。接続を確認してください。",
    timeout: "タイムアウトしました。",
    notFound: "データが見つかりませんでした。",
    unauthorized: "アクセス権限がありません。",
    sessionTimeout:
      "セッションの有効期限が切れました。再度ログインしてください。",
    heicNotSupported: "HEIC/HEIFファイルはサポートされていません。JPGまたはPNGを使用してください。",
    imageSupported: "JPG、JPEG、PNGファイルのみサポートされています。",
    ocrProductNotFound: "スキャンされたラベルに一致する商品が見つかりません。",
  },
  yourCodeIs: "コードは",
  validation: {
    required: "必須項目です",
    phoneInvalid: "無効な電話番号です",
    emailInvalid: "メールアドレスの形式が正しくありません",
    enterOTP: "OTPを入力してください",
    otpInvalid: "OTPは6桁で入力してください",
    uploadLimit: "最大 {number} 件までです",
    numberInvalid: "数値で入力してください",
    minCode: "少なくとも1つのコードを入力してください",
    maxFilesAllowed: "最大 {count} 個までアップロードできます",
    invalidFileFormat: "無効なファイル形式です。",
  },
  redeemAmount: "交換数量: {quantity}",
  duration: "期間",
  webAccessDenied: "アクセス拒否: このサイトを閲覧する権限がありません",
  webRedirecting: "正しいサイトへリダイレクト中...",
  or: "または",
  notEnough: "残高不足です",
  notAvailable: "利用不可",
  amount: "金額",
  message: "メッセージ",
  loginLineLoading: "LINEログイン中...",
  signinWithLine: "LINEでログイン",
  signinWithGoogle: "Googleでログイン",
  sampleImage: "サンプル画像",
  submitResult: "結果を送信",
  submit: "送信",
  unit: {
    km: "km",
    cc: "cc",
    unit: "個",
  },
  menuMain: "メイン",
  menuMore: "もっと見る",
  menuInformationCenter: "Info Center",
  menuInformationCenterFull: "Information Center",
  menuCampaign: "Campaign",
  menuRequest: "Request",
  menuWarranty: "Warranty",
  joinedCampaigns: "Joined Campaigns",
  campaignTotalPoint: "Total Point",
  campaignTotalAmount: "Total Amount",
  allRequest: "All Requests",
  newRequest: "New Request",
  textFilter: "Filter",
  textSortBy: "Sort by",
  textUpdated: "updated",
  textAttachmentCount: "{count} Attachments",
  textAttachmentFile: "Attachment Files",
  textFilePreview: "File Preview",
  textReply: "Reply",
  textReplyForm: "Reply Form",
  textForm: "Form",
  textFillInForm: "Fill in form",
  textPost: "Post",
  textInputComment: "Comment",
  textViewMoreComment: "View more comments",
  textViewMoreReply: "View more replies",
  textRewardCount: "× {count} item(s)",
  filterAll: "All",
  filterFavorite: "Favorited",
  filterUnread: "Unread",
  filterNoType: "No Type",
  filterReportStatus: "Status : {report_status_name}",
  sortDate: "Sort by Date",
  sortTitle: "Sort by Title",
  sortExpiredDate: "Sort by Expired Date",
  sortProduct: "Sort by Product",
  sortRegisterDate: "Sort by Register Date",
  clear: "Clear",
  addFavorite: "Add to Favorites",
  removeFavorite: "Remove from Favorites",
  extraBonus: "Extra Bonus",
  deliveryPickup: "Pickup",
  deliveryThailandPost: "Thailand Post",
  pleaseFillDetail: "please input detail here ...",
  textTitle: "Title",
  textSubtitle: "Subtitle",
  textType: "Type",
  textProduct: "Product",
  hintUploadMultiFile:
    "Max {fileLimit} files, maximum total file size is {fileLimitMB} MB",
  errorUploadLimitFileSize:
    "Total file size exceeds the {fileLimitMB} MB limit.",
  specialReward: "Claim your special reward!",
  totalSummaryPoint: "Total Points",
  transferPoint: "Transfer Points",
  confirmTransferPoint:
    "Are you sure you want to transfer {point} points to {name}?",
  transferSuccess: "Points transferred successfully",
  transferDescription: "Transfer points to another member",
  selectRecipient: "Select recipient",
  selectMember: "Select member",
  enterTransferPoints: "Enter the number of points to transfer",
  transferPointAmount: "Points to transfer",
  transferPointType: "Type of Points to Transfer",
  transferPoints: "Transfer points",
  totalPoint: "Total point",
  myPointAll: "All",
  myPointExpire: "Expiring Soon",
  myPointExchange: "Redeem",
  total: "Total",
  toMember: "To",
  remaining: "Remaining",
  max: "Max",
  allWarranty: "All Warranties",
  warranty: "Warranty",
  warrantyRegistration: "Warranty Registration",
  newProductWarranty: "New Product",
  registerWarrantyDescription: "Register your purchase to activate your warranty.",
  registerNow: "Register Now",
  serviceRequest: "Service Request",
  warrantyStatus: {
    active: "ACTIVE",
    pending: "PENDING",
    rejected: "REJECTED",
    expired: "EXPIRED",
  },
  textUploadProductLabel: "Upload Product Label",
  textAutoFillByAI: "Auto-fill details with AI ✨",
  textBtnSelectPhoto: "Select Photo",
  textViewSamplePhoto: "View sample photo",
  textNumberMore: "+{number} more",
  textHide: "hide",
  microsite: {
    invalidPhoneNumber: "Please enter a valid phone number",
    otpVerified: "Confirm OTP",
    sendRefCodeOtp: "Ref OTP",
    textRequireOTPAgain: "Request a new OTP code again within : ",
    requestOtpAgain: "Request OTP Again",
    confirmDefault: "Confirm",
    enterOTP: "Please enter the OTP",
    otpInvalid: "OTP must be 6 digits",
    textTransactionDetail: "Transaction Detail",
    createdAt: "Date",
    summary_amount: "Summary Amount",
    point: "Point",
    status: "Status",
    status_detail: "Status Detail",
    item_name: "Item Name",
    item_image: "Item Image",
    Approved: "Approved",
    Waiting: "Waiting Approval",
    Rejected: "Rejected",
    Pending: "Pending",
    privacyPolicy: "Privacy<br />policy",
    termAndCondition: "Terms &<br />conditions",
    textNext: "Next",
    acceptConsent: "I accept",
    dataNotFound: "Data Not Found",
    maxFileSizeAllowed: "File Size is less than {size} MB.",
    maxFilesAllowed: "You can upload maximum {count} files",
    errSubmissionFailed: "Sorry, your submission failed.",
    errGeneral: "Something went wrong. Please try again.",
    successOTPVerified: "OTP Verified successfully",
    textBack: "Back",
    errActivityAlreadyJoined: "Sorry, you have already joined this activity.",
    textRefresh: "Refresh",
    errActivity: "Sorry, you cannot join this activity.",
    textRegistrationHistory: "REGISTRATION HISTORY",
    textTotalPoint: "Total point",
    textTotalAmount: "Total amount",
    textHistory: "HISTORY",
    textNo: "No",
    textCode: "Code",
    textSuccess: "Success",
    textNotFound: "Not Found",
    textUsed: "Used",
    errUserNotFound: "Sorry, user not found.",
    loginSuccess: "Login successful.",
    registerSuccess: "Register successful.",
    textResultsSummary: "Results Summary",
    textTopRankingCampaign: "Top {num} Ranking",
    textRank: "Rank",
    textPhone: "Phone Number",
    textTotal: "Total",
    textLuckyDrawClaimed:
      "You have already claimed your Lucky Draw rights for this campaign.",
    textContactAdminToChange:
      "To change your selection, please contact administrator.",
    textConnectWithLine: "Connect with LINE",
    textBackHome: "Home",
  },
};
